import { Sparkles } from 'lucide-react';

/**
 * Línea de estado mientras se responde (opción a del dueño, 14-10; maqueta 2026-10-14-pensando.html): texto gris con
 * un brillo que lo recorre y el ícono girando despacio. Con `prefers-reduced-motion`, quieto (ver index.css).
 * Reemplaza los tres puntos y las etiquetas de colores de las herramientas.
 */
export default function StatusLine({ label }: { label: string }) {
  return (
    <div role="status" aria-live="polite" className="flex items-center gap-2 h-[22px] text-[13px] mb-1">
      <Sparkles className="w-3.5 h-3.5 text-slate-400 flex-none status-spin" strokeWidth={1.8} aria-hidden="true" />
      <span key={label} className="status-shine">{label}</span>
    </div>
  );
}
